import CSVPreviewSection from '../CSVPreviewSection'

export default function EstimateVsActualCSVPreviewHeader() {}

EstimateVsActualCSVPreviewHeader.prototype = new CSVPreviewSection();

EstimateVsActualCSVPreviewHeader.prototype.init = function( groupingLevelsArray, columnsConfig ){
    CSVPreviewSection.prototype.init.call( this );
    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsConfig = columnsConfig;
    
    return this;
};

EstimateVsActualCSVPreviewHeader.prototype.addRows = function( tBody )
{
    const mainHeaderRow = this.createRow("tableHeader")

    const length = this.groupingLevelsArray.length
    for (let i = 0; i < length; ++i) {
        const level = this.groupingLevelsArray[i]
        ReportPreviewUtils.addCell( mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(level) );
    }

    this.addCell( mainHeaderRow, this.message("report.budgeted_vs_actual.spent_time.total") );
    
    this.columnsConfig.addDataColumns(mainHeaderRow);
    
    this.addCell( mainHeaderRow, this.message("report.budgeted_vs_actual.estimated_time") );
    this.addCell( mainHeaderRow, this.message("report.budgeted_vs_actual.variance_mh") );
    this.addCell( mainHeaderRow, this.message("report.budgeted_vs_actual.variance_percent") );

    this.addRowWithAdditionalClass( tBody, mainHeaderRow );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/eva/EstimateVsActualCSVPreviewHeader.js